import type { Category, PlannedMeal, Recipe } from '../../lib/supabase'
import { coverModel } from '../../lib/recipeBook'
import { MEAL_SERVINGS_MAX, MEAL_SERVINGS_MIN } from '../../lib/mealPlan'
import { Stepper } from '../ui/Stepper'
import { CloseIcon } from '../icons'
import { Cover } from '../recipes/Cover'

// A meal on a day (feature spec 03 "Meal"): the cover beside the name (opens
// the recipe at these servings) and remove, over servings, On list once its
// ingredients went to the list, and Cook — "Cooked" once it was, which cooks again.
export function MealRow({ meal, recipe, dayLabel, photoUrl, categories, categoryFor, tintFor, onOpen, onRemove, onServings, onCook }: {
  meal: PlannedMeal
  recipe: Recipe
  dayLabel: string
  /** The recipe's photo (useRecipePhotos); none shows its generated cover. */
  photoUrl?: string | null
  categories: Category[]
  categoryFor: (name: string) => string | null
  tintFor: (categoryId: string | null) => string
  onOpen: () => void
  onRemove: () => void
  onServings: (n: number) => void
  onCook: () => void
}) {
  return (
    <li className={`ml-meal${meal.cooked ? ' is-cooked' : ''}`}>
      <Cover cover={coverModel(recipe, categoryFor, categories)} tintFor={tintFor} size="thumb" photoUrl={photoUrl} />
      <div className="ml-meal__body">
        <div className="ml-meal__top">
          <button type="button" className="ml-meal__name" aria-label={`Open ${recipe.title}`} onClick={onOpen}><span className="ml-clamp-2">{recipe.title}</span></button>
          <button type="button" className="ml-meal__remove" aria-label={`Remove ${recipe.title} from ${dayLabel}`} onClick={onRemove}>
            <CloseIcon size={16} />
          </button>
        </div>
        <div className="ml-meal__bottom">
          <Stepper value={meal.servings} min={MEAL_SERVINGS_MIN} max={MEAL_SERVINGS_MAX} label="Servings" of={recipe.title} size="sm"
            onChange={onServings} />
          {meal.added && <span className="ml-meal__badge"><span className="ml-meal__badge-dot" aria-hidden="true" />On list</span>}
          <button type="button" className={`ml-meal__cook${meal.cooked ? ' is-cooked' : ''}`}
            aria-label={meal.cooked ? `Cook ${recipe.title} again` : `Cook ${recipe.title}`} onClick={onCook}>
            {meal.cooked ? 'Cooked' : 'Cook'}
          </button>
        </div>
      </div>
    </li>
  )
}
